exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".terms-and-conditions-image{width:100%}@media (min-width:992px){.terms-and-conditions-image{width:auto}}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/sass-loader!./src/components/checkout/TermsAndConditions/TermsAndConditions.scss
 ** module id = 1235
 ** module chunks = 0
 **/